import { getEnv } from '../config';

export const isSSR = typeof window === 'undefined';
export const isNotSSR = !isSSR;

export const isProduction = getEnv('REACT_APP_APP_ENV') === 'production';
export const isNotProduction = !isProduction;

export const localStorageExists = typeof localStorage !== 'undefined';
